import { BoundingBox, Entity } from "playcanvas";

export function calculateBoundingBoxForEntity(
	root: Entity,
	/** Processes all descendants and adds them to the bounding box. */
	recursive: boolean,
	/** Custom filter for excluding entities (and their descendants) from being processing. */
	entityFilter?: (entity: Entity) => boolean,
	/** Existing bounding box to use and return instead of creating a new instance. */
	target?: BoundingBox,
): BoundingBox | undefined {
	let pending: Entity[] = [root];
	let current: Entity[] = [];
	let result: BoundingBox | undefined;

	while (pending.length > 0) {
		[current, pending] = [pending, current];
		pending.length = 0;

		for (const entity of current) {
			if (entityFilter && !entityFilter(entity)) {
				continue;
			}

			const model = entity.model ?? entity.render;
			if (model?.meshInstances) {
				for (const { visible, aabb } of model.meshInstances) {
					if (!visible) {
						continue;
					}
					if (result) {
						result.add(aabb);
					} else {
						result = target ?? new BoundingBox();
						result.copy(aabb);
					}
				}
			}

			if (recursive) {
				for (const child of entity.children) {
					if (child instanceof Entity) {
						pending.push(child);
					}
				}
			}
		}
	}

	return result;
}
